<template>
    <div class="tab-pane fade show active" id="pricing" role="tabpanel" aria-labelledby="pricing-tab">
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6 clearfix">
                    <h3 class="pt-2 mb-2">Product Children</h3>
                </div>
                <div class="col-md-6 text-right d-flex justify-content-end" v-if="$parent.permissionAllowed('manage_products') && !uiStates.addChildRelation">
                    <button class="btn btn-primary text-right mb-2 mr-1" @click="saveOrder">Save Children Order</button>
                    <button class="btn btn-primary text-right mb-2 mr-1" @click="createChild">Create Child</button>
                </div>
            </div>
            <div v-if="uiStates.addChildRelation" class="createChildWrapper">
                <div class="d-flex flex-column" v-for="(options, idx) in productOptionData" :key="idx">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <div class="options-label" v-text="'Select Option - ' + options.name" />
                        <div class="options-pagination">
                            Show
                            <select name="select-per-page" v-model="options.resultsPerPage">
                                <option>2</option>
                                <option>6</option>
                                <option>10</option>
                                <option>20</option>
                                <option>50</option>
                            </select>
                            entries
                        </div>
                    </div>
                    <select-item-from-provided-list
                        :items="adjustedOptionValues(options.values)"
                        :columns="['adjustedLabel']"
                        :results-per-page="options.resultsPerPage"
                        @selection="handleOptionSelection(idx, $event.valueId)">
                    </select-item-from-provided-list>
                </div>


                <select-item-from-api-provided-list
                    v-if="uiStates.showExistingProductSelect"
                    :api="'pimapi/products/' + this.$parent.product.info.id + '/child-candidates'"
                    list-label="Select Existing Product"
                    :columns="['name', 'sku']"
                    :results-per-page="10"
                    @selection="handleProductSelection">
                </select-item-from-api-provided-list>

                <div class="input-group d-flex flex-column text-right button-group-tall justify-content-between">
                    <div class="input-group-append d-flex justify-content-end">
                        <button
                            v-if="uiStates.showExistingProductSelect"
                            @click="addExistingChild()"
                            :disabled="existingChildId == null || !isOptionSelected"
                            class="btn btn-primary">Save</button>
                        <button
                            v-if="!uiStates.showExistingProductSelect"
                            @click="loadProductListing()"
                            class="btn btn-primary">Use Existing Product</button>
                        <button
                            v-if="!uiStates.showExistingProductSelect"
                            @click.prevent="createNewChildFromProduct()"
                            :disabled="!isOptionSelected"
                            class="btn btn-primary ml-1">Save Child Product</button>
                        <button class="btn btn-default text-right ml-1" @click="resetForm()">Cancel</button>
                    </div>
                    <div class="create-child-warning" v-if="!isOptionSelected">* Select Option</div>
                    <div class="create-child-warning" v-if="uiStates.showExistingProductSelect && existingChildId == null && isOptionSelected">* Select Product</div>
                </div>
            </div>
            <div class="row mb-3" v-if="hasChildren && $parent.permissionAllowed('manage_products')">
                <div class="col-md-12">
                    <div class="btn-group border w-100 p-2 d-flex justify-content-start">
                        <div class="d-flex align-items-center mx-2 text-left w-50"><strong>Set All Children</strong></div>
                        <div class="d-flex w-100 justify-content-end align-items-center">
                            <button type="button" class="btn btn-primary btn-sm mr-1" @click="setChildStatus(true)">Online</button>
                            <button type="button" class="btn btn-danger btn-sm" @click="setChildStatus(false)">Offline</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div data-toggle="tooltip" data-placement="top" :title="bulkChildrenButtonTooltip" style="white-space: pre-line" class="col-md-2" v-if="!isDisabled">
                    <div class="btn-group w-100 d-flex justify-content-start">
                        <button class="btn btn-primary text-right mb-2 mr-1 bulkRemoveButton" @click="bulkRemoveFromParent" :disabled="!isDisabled">Bulk Remove from Parent</button>
                    </div>
                </div>
                <div class="col-md-2" v-if="isDisabled">
                    <div class="btn-group w-100 d-flex justify-content-start">
                        <button class="btn btn-primary text-right mb-2 mr-1 bulkRemoveButton" @click="bulkRemoveFromParent" :disabled="!isDisabled">Bulk Remove from Parent</button>
                    </div>
                </div>
            </div>
            <div class="children-list-wrapper pl-3 pr-3">
                <div class="row pb-1 mb-3 pt-0 border-bottom">
                    <div class="col-md-1">
                        <div v-if="$parent.permissionAllowed('manage_products')" class="dropdown">
                            <i class="fa fa-plus multi-select-dropdown" aria-hidden="true" @click="handleSelectDropdownClick"></i>
                            <div class="dropdown-menu" id="select-dropdown">
                                <span class="dropdown-item" @click="handleSelectAll" v-if="!isAllSelected">
                                    <span class="item-copy">Select All</span>
                                </span>
                                <span class="dropdown-item" @click="handleSelectNone" v-if="isAllSelected || (selectedCount > 0 || selectedCount === 'all')">
                                    <span class="item-copy">Select None</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1">&nbsp;</div>
                    <div class="col-md-2 font-weight-bold">Name</div>
                    <div class="col-md-1 font-weight-bold">Options</div>
                    <div class="col-md-1 font-weight-bold">Saleable</div>
                    <div class="col-md-1 font-weight-bold">PIM ID</div>
                    <div class="col-md-1 font-weight-bold">SKU</div>
                    <div class="col-md-1 font-weight-bold">Barcodes</div>
                    <div class="col-md-1 font-weight-bold">Channels</div>
                    <div class="col-md-1 font-weight-bold">Status</div>
                    <div class="col-md-1">&nbsp;</div>
                </div>
                <draggable v-model="children">
                    <div v-for="(child, index) in children" :key="child.id" class="row pb-3 mb-3 pt-0 border-bottom d-flex align-items-center">
                        <div class="col-md-1 d-flex justify-content-between align-items-center" >
                            <div>
                                <input type="checkbox" class="product-select-checkbox" v-model="bulkChildrenSelected" :value="child.id" @change="handleCheckboxChangeOnProduct(child)">
                            </div>
                            <div class="ml-1">
                                <a class="download-link" :href="child.thumbnailuri" download target="_blank">
                                    <div v-if="child.thumbnailuri != null" class="thumbnail-container border border-radius p-3" :style="{backgroundImage: `url('${child.thumbnailuri}')` }"></div>
                                    <div v-else class="thumbnail-container productthumbnail_disabled border border-radius p-3"><i class="fa fa-picture-o"></i></div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3"><a class="ml-2 d-flex" :href="'/products/'+child.id+'/edit'">{{child.name}}</a></div>
                        <div class="col-md-1"><div v-for="(option, optionIdx) in child.options" :key="optionIdx">{{option}}</div></div>
                        <div class="col-md-1">{{child.saleable}}</div>
                        <div class="col-md-1">{{child.id}}</div>
                        <div class="col-md-1 breaking-column">
                            <div :style="{ overflow: currentActiveSKU === child.sku ? 'unset' : 'hidden' }">
                                <button class="sku-btn btn p-0 d-flex justify-content-start font-weight-normal" style="color: #333; background: transparent;" @click="copySKUToClipboard(child.sku)" @mouseover="(currentActiveSKU = child.sku)" @mouseleave="(currentActiveSKU = '')">
                                    <span v-if="(currentActiveSKU === child.sku)" class="position-absolute" style="color: #333;">
                                        <i class="fa fa-copy"></i>
                                    </span>
                                    <span class="pl-0 ml-3" :class="{ 'sku-hovered': currentActiveSKU === child.sku }">
                                        {{child.sku}}
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-1 breaking-column"><div v-for="(barcode, barcodesIdx) in child.barcodes" :key="barcodesIdx">{{barcode}}</div></div>
                        <div class="col-md-1"><div v-for="(channel, channelIdx) in child.channels" :key="channelIdx">{{channel}}</div></div>
                        <div class="col-md-1" v-if="child.enabled == 1">
                            <div class="badge badge-success w-100">Online</div>
                        </div>
                        <div class="col-md-1" v-if="child.enabled != 1">
                            <div class="badge badge-danger w-100">Offline</div>
                        </div>
                        <div class="col-md-1">
                            <div class="" v-if="$parent.permissionAllowed('manage_products')">
                                <div class="dropdown channel-tool-menu text-right ml-1">
                                    <button type="button" class="btn btn-outline-primary " data-toggle="dropdown">
                                        <i class="fa fa-cog" aria-hidden="true"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                                        <a class="dropdown-item" @click="removeFromParent(child.id)">
                                            <span>Remove From Parent</span>
                                        </a>
                                        <a class="dropdown-item" :href="'/products/'+child.id+'/edit'">
                                            <span>Edit child product</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="d-flex justify-content-between pl-3 pr-3">
                <div class="per-page-selection">
                    Show
                    <select name="select-per-page" @change="handlePerPageChange" v-model="perPage">
                        <option v-for="(amount, index) in amountsShown" :key="index" :value="amount.value">{{amount.text}}</option>
                    </select>
                    entries
                </div>
                <paginator v-if="paginationData.last_page > 1" :pagination="paginationData" @paginate="handlePaginateChange"></paginator>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade modern" id="confirmDeleteChildProduct" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Are you sure?</h5>
                    </div>
                    <div class="modal-body">
                        <p>This will completely remove the child product and delete it from all channels where it is currently published.</p>
                    </div>
                    <div class="modal-footer" style="border-top: 0px !important;">
                        <div class="form-group footer-form-group">
                            <label class="text-left w-100" for="">Type <strong>"DELETE"</strong> to confirm</label>
                            <input type="text" class="form-control" aria-describedby="helpId" placeholder="" v-model="modal.confirmation">
                        </div>
                        <button @click="modal.confirmation = ''" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button :disabled="modal.confirmation != 'DELETE'" class="btn btn-danger" data-dismiss="modal" v-on:click.prevent="deleteProductChild(modal.idToDelete)">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host;

import Vue from "vue";
import Paginator from "../generic/tables/pagination.vue";
import VueEvents from "vue-events";
import axios from "axios";
import SelectItemFromApiProvidedList from "../generic/select-item-from-api-provided-list.vue";
import SelectItemFromProvidedList from "../generic/select-item-from-provided-list.vue";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import draggable from 'vuedraggable';

Vue.use(VueEvents);

export default {
    name: "product-details-children",
    components: {
        paginator: Paginator,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "select-item-from-provided-list": SelectItemFromProvidedList,
        "select-item-from-api-provided-list": SelectItemFromApiProvidedList,
        draggable,
    },
    mounted() {
        this.loadPivots();
        this.loadProductChildren();
    },
    data() {
        return {
            modal: {
                confirmation: "",
                idToDelete: null
            },
            productOptionData: [],
            pivots: [],
            isOptionSelected: false,
            loading: true,
            existingChildId: null,
            productOptionsGroupId: null,
            children: [],
            currentPage: 1,
            perPage: 50,
            paginationData: {
                to: true,
                last_page: 0,
                current_page: 0
            },
            amountsShown: [
                { text: "10", value: 10 },
                { text: "25", value: 25 },
                { text: "50", value: 50 },
                { text: "100", value: 100 }
            ],
            uiStates: {
                addProductRelation: false,
                addChildRelation: false,
                showLoading: false,
                showExistingProductSelect: false
            },
            ProductListing: {
                products: []
            },
            optionsPagination: 6,
            isAllSelected: false,
            selectedCount: 0,
            bulkChildrenSelected: [],
            bulkChildrenButtonTooltip: "Select Children to Remove",
            currentActiveSKU: ''
        };
    },
    computed: {
        hasChildren() {
            return this.children.length > 0;
        },
        optionsSet() {
            return this.$parent.productOptionData;
        },
        productAdjustedList() {
            let keys = Object.keys(this.ProductListing.products);
            return keys.map(key => {
                return { id: key, product: this.ProductListing.products[key] };
            });
        },
        isDisabled() {
            return this.hasChildren && this.$parent.permissionAllowed('manage_products') && this.bulkChildrenSelected.length > 0;
        }
    },
    methods: {
        async copySKUToClipboard(sku) {
            try {
                await navigator.clipboard.writeText(sku);
                this.$parent.alert = { message: 'Copied to clipboard', status: 'alert-success' };
            } catch (err) {
                console.error('Failed to copy: ', err);
            }
        },
        handleOptionsPagination(value) {
            this.optionsPagination = value;
        },
        handlePerPageChange() {
            this.currentPage = 1;
            this.loadProductChildren();
        },
        handlePaginateChange(pageClicked) {
            this.currentPage = pageClicked;
            this.loadProductChildren();
        },
        adjustedOptionValues(list) {
            return list.map(el => {
                return {
                    adjustedLabel: el.label + " (" + el.value + ")",
                    valueId: el.valueId
                };
            });
        },
        handleProductSelection(value) {
            this.existingChildId = value.id;
        },
        handleOptionSelection(idx, selection) {
            this.isOptionSelected = true;
            this.pivots[idx] = selection + "";
        },
        createChild() {
            this.uiStates.addChildRelation = true;
        },
        optionLabelWithValue(option) {
            if (option.label == option.value) {
                return option.label;
            }
            return `${option.label} (${option.value})`;
        },
        launchChildDeleteModal(id) {
            this.modal.idToDelete = id;
            $("#confirmDeleteChildProduct").modal();
        },
        getOptionValueId(options) {
            if (options.length < 1) {
                return;
            }
            this.pivots = [];
            let optionValues = [];
            options.forEach(opt => {
                this.productOptionData.forEach(data => {
                    data.values.forEach((val, index) => {
                        if (val.label === opt.split(": ")[1]) {
                            this.pivots.push(val.valueId);
                        }
                    });
                });
            });
            this.pivots.forEach((pivot, index) => {
                $(`#edit_attribute_select-${index}`).val(pivot);
                $(`#edit_attribute_select-${index}`).trigger("change");
            });
        },
        clearPivots() {
            this.pivots = [];
            $(".attribute_select").val(this.pivots);
            $(".attribute_select").trigger("change");
        },
        loadPivots() {
            for (var i = 0; i < this.productOptionData.length; i++) {
                this.pivots.push([]);
            }
        },
        removeFromParent(id) {
            this.loading = true;
            axios
                .delete(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/children/" +
                        id,
                    {}
                )
                .then(
                    function(res) {
                        this.loadProductChildren();
                        this.loading = false;
                        this.$parent.alert.status = "alert-success";
                        this.$parent.alert.message =
                            "The product child (id: " +
                            id +
                            ") has been removed from its parent";
                    }.bind(this)
                )
                .catch(
                    function(err) {
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message = err.response.data.message;
                    }.bind(this)
                );
        },
        loadProductListing: function() {
            this.loading = true;
            axios
                .get(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/child-candidates",
                    {}
                )
                .then(
                    function(response) {
                        this.loading = false;
                        this.uiStates.showExistingProductSelect = !this.uiStates
                            .showExistingProductSelect;
                        this.ProductListing.products =
                            response.data.payload.allProducts;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.loading = false;
                        this.uiStates.errorMessage = "An error has occured!";
                    }.bind(this)
                );
        },
        createNewChildFromProduct() {
            this.loading = true;
            let id = this.productOptionsGroupId;
            let childData = {};
            childData.pivots = this.getData();
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/create-new-child",
                    {
                        childData: childData
                    }
                )
                .then(
                    function(response) {
                        if (typeof response.data == "string") {
                            this.$parent.alert.message = response.data;
                        } else {
                            this.$parent.alert.message =
                                "A new product child has been added";
                            this.$parent.alert.status = "alert-success";
                        }
                        this.$parent.hasChildren = true;
                        this.loading = false;
                        this.loadProductChildren();
                        this.resetForm();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.$parent.alert.message =
                            error.response.data.message;
                        this.$parent.alert.status = "alert-danger";
                        this.resetForm();
                        console.log(error);
                    }.bind(this)
                );
        },
        getData: function() {
            let data = [];
            for (var i = 0; i < this.productOptionData.length; i++) {
                let option_set = this.productOptionData[i];
                let val = this.pivots[i];
                if (val === null || val === undefined) {
                    val = "";
                }
                data.push([option_set.id, val]);
            }
            return data;
        },
        addExistingChild: function() {
            this.loading = true;
            let id = this.productOptionsGroupId;
            let childData = {};
            childData.pivots = this.getData();
            childData.existing_product_id = this.existingChildId;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/add-existing-child",
                    {
                        childData: childData
                    }
                )
                .then(
                    function(response) {
                        if (response.data.status) {
                            this.$parent.alert.status = "alert-success";
                        } else {
                            this.$parent.alert.status = "alert-danger";
                        }
                        this.uiStates.showExistingProductSelect = !this.uiStates
                            .showExistingProductSelect;
                        this.$parent.alert.message = response.data.message;
                        this.loading = false;
                        this.loadProductChildren();
                        this.$parent.hasChildren = true;
                        this.resetForm();
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        console.log(error);
                        this.$parent.alert.message =
                            error.response.data.message;
                        this.$parent.alert.status = "alert-danger";
                        this.loading = false;
                        this.resetForm();
                    }.bind(this)
                );
        },
        loadProductChildren: function() {
            this.loading = true;
            axios
                .get(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/children?page=" +
                        this.currentPage +
                        "&per_page=" +
                        this.perPage,
                    {}
                )
                .then(
                    function(response) {
                        // add resultsPerPage value for each individual options set
                        this.productOptionData = response.data.optionData.map(
                            options => {
                                options.resultsPerPage = 6;
                                return options;
                            }
                        );
                        this.children = response.data.childData;
                        this.paginationData = response.data.meta;
                        this.loading = false;
                        if (this.children.length > 0) {
                            this.$parent.hasChildren = 1;
                        } else {
                            this.$parent.hasChildren = 0;
                        }
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.errorMessage = "An error has occured!";
                        this.loading = false;
                    }.bind(this)
                );
        },
        autoCreateChildren() {
            this.loading = true;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/autocreate",
                    {}
                )
                .then(
                    function(response) {
                        this.loadProductChildren();
                        this.loading = false;
                        this.$parent.alert.message =
                            "Child products created automatically";
                        this.$parent.alert.status = "alert-success";
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        deleteProductChild(id) {
            this.loading = true;
            axios
                .delete(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/delete-child/" +
                        id,
                    {}
                )
                .then(
                    function(response) {
                        this.loadProductChildren();
                        this.loading = false;
                        this.$parent.alert.message =
                            "Product child id: " + id + " has been deleted!";
                        this.$parent.alert.status = "alert-success";
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        console.log(error);
                    }.bind(this)
                );
        },
        setChildStatus(status) {
            this.loading = true;
            axios
                .post(
                    base_url +
                        "/pimapi/products/" +
                        this.$parent.product.info.id +
                        "/child-status",
                    {
                        childData: {
                            isOnline: status
                        }
                    }
                )
                .then(
                    function(response) {
                        this.$parent.alert.message =
                            "Child products order changed!";
                        this.$parent.alert.status = "alert-success";
                        this.loadProductChildren();
                        this.loading = false;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message =
                            error.response.data.message;
                        console.log(error);
                    }.bind(this)
                );
        },
        onLoaded: function() {
            this.loading = false;
        },
        collapseForm: function() {
            $("#create_child").collapse("hide");
        },
        resetForm() {
            this.isOptionSelected = false;
            this.uiStates.showExistingProductSelect = false;
            this.uiStates.addChildRelation = false;
        },
        saveOrder() {
            this.loading = true;
            axios
                .post(
                    base_url +
                    "/pimapi/products/" +
                    this.$parent.product.info.id +
                    "/override-sort-order",
                    {
                        childData: {
                            children: this.children
                        }
                    }
                )
                .then(
                    function(response) {
                        this.$parent.alert.message =
                            "Child product status changed!";
                        this.$parent.alert.status = "alert-success";
                        this.loadProductChildren();
                        this.loading = false;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message =
                            error.response.data.message;
                    }.bind(this)
                );
        },
        handleSelectDropdownClick() {
            $("#select-dropdown").show();
        },
        handleSelectAll(value) {
            $("#select-dropdown").hide();
            this.showGeneralLoadIndicator = true;

            let selected = [];
            if(value) {
                this.children.forEach(child => {
                    selected.push(child.id);
                    this.selectedCount += 1;
                });
                this.isAllSelected = true;
            }
            this.bulkChildrenSelected = selected;
        },
        handleSelectNone() {
            $("#select-dropdown").hide();
            this.showGeneralLoadIndicator = true;
            this.children.forEach(child => {
                child.isChecked = false;
            });
            this.bulkChildrenSelected = [];
            this.selectedCount = 0;
            this.isAllSelected = false;
        },
        handleCheckboxChangeOnProduct(child) {
            this.showGeneralLoadIndicator = true;
            if (this.children.length === this.bulkChildrenSelected.length) {
                this.isAllSelected = true;
            } else {
                this.isAllSelected = false;
            }
        },
        bulkRemoveFromParent() {
            this.loading = true;
            axios
                .post(
                    base_url +
                    "/pimapi/products/" +
                    this.$parent.product.info.id +
                    "/children/bulkdelete",
                    {
                        childData: this.bulkChildrenSelected
                    }
                )
                .then(
                    function(res) {
                        this.bulkChildrenSelected = [];
                        this.selectedCount = 0;
                        this.isAllSelected = false;
                        this.loadProductChildren();
                        this.loading = false;
                        this.$parent.alert.status = "alert-success";
                        this.$parent.alert.message = "Selected product childred have been removed from its parent";
                    }.bind(this)
                )
                .catch(
                    function(err) {
                        this.$parent.alert.status = "alert-danger";
                        this.$parent.alert.message = err.response.data.message;
                    }.bind(this)
                );
        }
    }
};
</script>

<style scoped lang="scss">
.button-group-tall {
    height: 65px;
}
.create-child-warning {
    color: red;
    font-size: 0.8em;
}
.select2-container--default {
    flex-grow: 100 !important;
}
.breaking-column {
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
}
.createChildWrapper {
    margin-bottom: 40px;
}
.channel-tool-menu {
    display: inline;
    .btn {
        margin-top: -1px;
        width: 26px;
        height: 26px;
        padding: 0 0;
        border-color: #adadad;
        color: #686868;
    }
}
.thumbnail-container {
    position: relative;
    width: 5rem;
    height: 5rem;
    background-size: cover;
    background-position: center;
    &:not(.productthumbnail_disabled) {
        &:after {
            transition: opacity 0.2s linear;
            opacity: 0;
            cursor: pointer;
            position: absolute;
            content: "\F1BD";
            z-index: 2;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            font: normal normal normal 22px/1 "LineAwesome";
            padding-top: 1.75rem;
            color: white;
            border-radius: 5px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
        }
        &:hover {
            &:after {
                transition: opacity 0.2s linear;
                opacity: 1;
            }
        }
    }
    &.productthumbnail_disabled i {
        margin-top: 10px;
    }
}
.modal-body {
    p {
        color: #ab5755;
        font-size: 14px;
    }
}
.modal-title {
    font-size: 16px;
}
.modal-footer {
    label {
        font-size: 11px;
    }
    border-top: 0;
    padding-top: 0;
}
.footer-form-group {
    width: 100%;
}
.options-label {
    font-size: 17px;
}
.options-pagination {
    select {
        border: none;
        background-image: none;
        background-color: transparent;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        font-family: "LatoWeb";
    }
}
.bulkRemoveButton:disabled {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    opacity: 0.65 !important;
}

.sku-hovered {
    background: #ffffffdd;
    z-index: 1;
    padding-right: 1rem;
}
</style>
